const getters = {
  is_android_wechat: state => state.app.is_android_wechat,
  is_android_wework: state => state.app.is_android_wework,
  is_iphone_wechat: state => state.app.is_iphone_wechat,
  is_iphone_wework: state => state.app.is_iphone_wework,
  is_windows_wechat: state => state.app.is_windows_wechat,
  is_windows_wework: state => state.app.is_windows_wework,
  is_mac_wechat: state => state.app.is_mac_wechat,
  is_mac_wework: state => state.app.is_mac_wework,
  is_miniprogram: state => state.app.is_miniprogram,
  mp_version: state => state.app.mp_version,
  
  realname: state => state.user.realname || state.user.nickname,
  nickname: state => state.user.nickname,
  user_id: state => state.user.id,
  avatar: state => state.user.avatar,
  subscribe: state => state.user.subscribe,
  reward_total: state => state.user.reward_total,
  reward: state => state.user.reward,
  drops: state => state.user.drops,
  mp_active_time: state => state.user.mp_active_time,
  is_mp_active: state => state.user.is_mp_active,
  flowers: state => Math.floor(state.user.drops/100),
  mobile: state => state.user.mobile,
  parent_mp_subscribe: state => state.user.parent_mp_subscribe,
  teacher_mp_subscribe: state => state.user.teacher_mp_subscribe,
  new_mp_subscribe: state => state.user.new_mp_subscribe,
  class_roles: state => state.user.class_roles,
  show_vedio: state => state.app.show_vedio,
  show_global_message: state => state.app.show_global_message,

  // 当前用户教授科目
  user_teach_subject: (state) => {
    let subject = null
    const subjects = state.app.subject_options

    let teacherRole = null
    const roles = state.user.class_roles
    const subjectIds = []
    roles.forEach((classInfo) => {
      classInfo.teacher_lists.forEach((teacher) => {
        subjectIds.push(teacher.subject_id)
      })
    })

    if (subjectIds.length > 0) {
      subjects.forEach((item) => {
        if (!subject && subjectIds.indexOf(item.id) >= 0) {
          subject = item
        }
      })
    }

    return subject
  },

  admin_roles: (state) => {
    const adminRoles = []
    const roles = state.user.class_roles

    roles.forEach((classInfo) => {
      if (classInfo.teacher_lists.length > 0) {
        adminRoles.push(classInfo)

      } else if (classInfo.parent_lists.length > 0) {
        classInfo.parent_lists.forEach((parent) => {
          if (parent.is_admin) {
            adminRoles.push(classInfo)
          }
        })
      }
    })

    return adminRoles
  },

  // 当前用户的所有教师身份
  teacher_roles: (state) => {
    const teacher_roles = []
    const roles = state.user.class_roles

    roles.forEach((classInfo) => {
      classInfo.teacher_lists.forEach((teacher) => {
        teacher_roles.push(classInfo)
      })
    })
    // 排序，把当班主任的班放在前面
    teacher_roles.sort((a, b) => {
      var a_is = a.teacher_lists[0].is_admin
      var b_is = b.teacher_lists[0].is_admin
      return b_is - a_is
    })
    return teacher_roles
  },
  // 当前用户的所有家长身份
  parent_roles: (state) => {
    const parent_roles = []
    const roles = state.user.class_roles

    roles.forEach((classInfo) => {
      classInfo.parent_lists.forEach((parent) => {
        parent_roles.push(classInfo)
      })
    })
      // 排序，把当家委会的班放在前面
      parent_roles.sort((a, b) => {
      var a_is = a.parent_lists[0].is_admin
      var b_is = b.parent_lists[0].is_admin
      return b_is - a_is
    })

    return parent_roles
  },
  head_teacher_roles: (state) => {
    const teacher_roles = []
    const roles = state.user.class_roles

    roles.forEach((classInfo) => {
      if (classInfo.teacher_lists.length > 0) {
        classInfo.teacher_lists.forEach((teacher) => {
          if (teacher.is_admin) {
            teacher_roles.push(classInfo)
          }
        })
      }
    })

    return teacher_roles
  },
  committee_roles: (state) => {
    const committee_roles = []
    const roles = state.user.class_roles
    let hasRole = false

    roles.forEach((classInfo) => {
      if (classInfo.parent_lists) {
        classInfo.parent_lists.forEach((parent) => {
          if (parent.is_admin) {
            committee_roles.push(classInfo)
          }
        })
      }
    })
    return committee_roles
  },
  // 当前用户是否有教师的角色
  has_teacher_role: (state) => {
    const roles = state.user.class_roles
    let hasRole = false
    roles.forEach((classInfo) => {
      if (classInfo.teacher_lists.length > 0) {
        hasRole = true
      }
    })

    return hasRole
  },

  has_parent_role: (state) => {
    const parent_roles = []
    const roles = state.user.class_roles
    roles.forEach((classInfo) => {
      classInfo.parent_lists.forEach((parent) => {
        parent_roles.push(classInfo)
      })
    })
    return parent_roles.length > 0
  },
  has_committee_role: (state) => {
    const committee_roles = []
    const roles = state.user.class_roles

    roles.forEach((classInfo) => {
      if (classInfo.parent_lists) {
        classInfo.parent_lists.forEach((parent) => {
          if (parent.is_admin) {
            committee_roles.push(classInfo)
          }
        })
      }
    })
    return committee_roles.length > 0
  },

  is_wechat: (state) => {
    return state.app.is_wechat
  },
  is_wework: (state) => {
    return state.app.is_android_wework || state.app.is_iphone_wework || state.app.is_windows_wework || state.app.is_mac_wework
  },
  is_mobile_client: (state) => {
    return state.app.is_android_wechat || state.app.is_iphone_wechat || state.app.is_android_wework || state.app.is_iphone_wework
  },
  is_pc_client: (state) => {
    return state.app.is_windows_wechat || state.app.is_mac_wechat || state.app.is_windows_wework || state.app.is_mac_wework
  },
  is_mac_client: (state) => {
    return state.app.is_mac_wechat || state.app.is_mac_wework
  },
  is_windows_client: (state) => {
    return state.app.is_windows_wework || state.app.is_windows_wechat
  },
  is_in_client: (state) => {
    return state.app.is_android_wechat || state.app.is_iphone_wechat || state.app.is_android_wework || state.app.is_iphone_wework || state.app.is_windows_wechat || state.app.is_mac_wechat || state.app.is_windows_wework || state.app.is_mac_wework
  },
  is_in_web: (state) => {
    return navigator.userAgent.indexOf('MicroMessenger') < 0
  },
  is_mobile_wework: (state) => {
    return state.app.is_android_wework || state.app.is_iphone_wework
  },
  is_iphone_client: (state) => {
    return state.app.is_iphone_wechat || state.app.is_iphone_wework
  },

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js